@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.NoSideMenu {
  padding-left: 0;
}

.content {
  @include content;
}

.body {
  @include body;
}

.ScheduleAlertWrapper {
  padding: spacing('24') spacing('24') spacing('0');
}

.BannerWrapper {
  position: fixed;
  bottom: spacing('24');
  right: spacing('24');
}
